import o from"./index.module.scss.js";const s=o;export{s as AnimationTheme};
//# sourceMappingURL=index.js.map
